import {useEffect, useState} from "react";
import TextButton from "../../UI/TextButton/TextButton";
import "./SideBarComponent.scss";
import {Subscription} from "rxjs";
import {eventService} from "../../services/Events.service";

const SideBarComponent = () => {
  const [activeOption, setActiveOption] = useState<string | null>("Басейн");
  const [isSideBarOpen, setSideBarSate] = useState<boolean>(false);

  useEffect(() => {
    const sub: Subscription = eventService.getClickStream().subscribe((option: string) => {
      setActiveOption(option);
    });

    return () => sub.unsubscribe();
  }, []);

  return (
    <div className={`sidebar_container ${isSideBarOpen ? "open" : ""}`}>
        <div className="sidebar_header">
          <div className="header_control">
            {isSideBarOpen ? (
              <img onClick={() => setSideBarSate(!isSideBarOpen)} src="/assets/icons/cross.png" alt="Close" />
            ) : <img onClick={() => setSideBarSate(!isSideBarOpen)} src="/assets/icons/arrow-right.png" alt="Close" />}
          </div>
        </div>
        <div className="options">
          <TextButton text="Басейн" isActive={activeOption === "Басейн"} />
          <TextButton text="ГЕС" isActive={activeOption === "ГЕС"} />
          <TextButton text="Моніторинг" isActive={activeOption === "Моніторинг"} />
          <TextButton text="Поверхневі води" isActive={activeOption === "Поверхневі води"} />
          <TextButton text="Гідротехнічні споруди для ліквідації" isActive={activeOption === "Гідротехнічні споруди для ліквідації"} />
        </div>
        <div className='disclaimer'>Встановлені режими роботи штучних водних об’єктів розміщуються на офіційних вебсайтах БУВР та РОВР (з урахуванням вимог публікації інформації в умовах воєнного стану), надсилаються користувачам водних об’єктів, органам державної влади та місцевого самоврядування</div>
    </div>
  );
};

export default SideBarComponent;